import { Link } from "react-router-dom";

function Welcome({ mode }) {
  return (
    <div className="welcome">

      {/* LEFT TEXT */}
      <div className="welcome-text">
        <h2>
          {mode === "school"
            ? "Welcome to Tejkirti Little Star Pre-School"
            : "Welcome to Tejkirti Senior Women’s College"}
        </h2>

        <h4>
          {mode === "school"
            ? "We provide a safe, joyful and nurturing environment where young children learn through play, creativity and guided activities."
            : "Our college is dedicated to empowering women through quality education, academic excellence, and holistic development."}
        </h4>

        {/* ✅ REPLACED WITH YOUR COLLEGE DETAILS */}
        {mode === "college" && (
          <p className="welcome-extra">
            Established under <strong>Adarsh Shikshan Prasarak Mandal</strong>, 
            Tejkirti Senior Women’s College has become a center of excellence 
            for women’s education in Chhatrapati Sambhajinagar.

            <br /><br />

            The college is affiliated to{" "}
            <a
              href="https://sndt.digitaluniversity.ac/"
              target="_blank"
              rel="noopener noreferrer"
            >
              S.N.D.T. Women’s University, Mumbai
            </a>{" "}
            and offers quality education in Arts, Commerce, and Science streams.
            <br />
            We focus on overall development by encouraging academic growth, 
            leadership skills, and social responsibility, providing a safe 
            and inspiring environment for every student.
          </p>
        )}

        <Link to="/about" className="btn">
          Learn More
        </Link>
      </div>

      {/* RIGHT IMAGE */}
      <div className="welcome-img">
        <img
          src={
            mode === "school"
              ? "/school-new.jpg"
              : "/college-new.jpg"
          }
          alt="campus"
        />
      </div>

    </div>
  );
}

export default Welcome;